const CheckStep = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1295_1766)">
            <circle cx="8" cy="8" r="8" fill="#E7FCED"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M14.6663 8.00001C14.6663 11.6819 11.6816 14.6667 7.99967 14.6667C4.31778 14.6667 1.33301 11.6819 1.33301 8.00001C1.33301 4.31811 4.31778 1.33334 7.99967 1.33334C11.6816 1.33334 14.6663 4.31811 14.6663 8.00001ZM10.6866 5.97979C10.8818 6.17505 10.8818 6.49163 10.6866 6.6869L7.35323 10.0202C7.15797 10.2155 6.84138 10.2155 6.64612 10.0202L5.31279 8.6869C5.11753 8.49164 5.11753 8.17505 5.31279 7.97979C5.50805 7.78453 5.82463 7.78453 6.01989 7.97979L6.99967 8.95957L8.48956 7.46968L9.97945 5.97979C10.1747 5.78453 10.4913 5.78453 10.6866 5.97979Z" fill="#24C450"/>
            </g>
            <defs>
            <clipPath id="clip0_1295_1766">
            <rect width="16" height="16" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    )
}

export default CheckStep